import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../_services';
import {emailValidator} from '../../_validators/validators';
import {Router} from '@angular/router';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.css']
})
export class VerificationCodeComponent implements OnInit {

  public activateAccountForm: FormGroup;
  // public submitted: boolean;
  public loading: boolean;
  public error: '';
  public success: '';
  // public serverResponse: any;
  private loginUrl: string;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.activateAccountForm = this.formBuilder.group({
      verificationCode: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
    });
  }

  ngOnInit(): void {
    this.loginUrl = 'login';
  }

  get a() {
    return this.activateAccountForm.controls;
  }

  activateAccount() {
    this.authenticationService.activateAccount(this.a.verificationCode.value)
      .subscribe(resp => {
        console.log(resp);
        this.router.navigate([this.loginUrl]);
        },
        error => {
          this.error = error;
          console.log(error);
        }
      );

  }
}
